var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-container"},[_c('h2',[_vm._v("前后端连接测试")]),_c('button',{on:{"click":_vm.testConnection}},[_vm._v("测试连接")]),(_vm.result)?_c('div',{staticClass:"result"},[_c('p',[_vm._v("响应结果："+_vm._s(_vm.result))])]):_vm._e(),(_vm.error)?_c('div',{staticClass:"error"},[_c('p',[_vm._v("错误信息："+_vm._s(_vm.error))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }